import type { CSSProperties, ReactNode } from "react";

export default function SectionCard({ children, style }: { children: ReactNode; style?: CSSProperties }) {
  return (
    <div style={{
      border: "1px solid #e5e7eb",
      borderRadius: 12,
      padding: 16,
      marginBottom: 16,
      background: "#fff",
      ...style
    }}>
      {children}
    </div>
  );
}
